import React from 'react'
import Hero from './Hero'
import Intro from './Intro'
import Form from './Form'

const ContactMe = () => {
  return (
    <>
    <Hero/>
    <Intro/>
    <Form/>
    </>
  )
}

export default ContactMe